import React from 'react';


export type Environment = {
  appNameSpace: string;
  restApi: string;
  authUrl: string;
};


export const EnvironmentContext = React.createContext<Environment | undefined>(undefined);


export const EnvironmentProvider: React.FC<{ environment: Environment; children: React.ReactNode }> = ({ environment, children }) => {
  return (
    <EnvironmentContext.Provider value={environment}>
      {children}
    </EnvironmentContext.Provider>
  );
};


export const useEnvironment = () => {
  const environment = React.useContext(EnvironmentContext);

  if (!environment) {
    throw new Error('useEnvironment must be used within an EnvironmentProvider');
  }

  return environment;
};
